import React from 'react';
import CheckCircle from '@mui/icons-material/CheckCircle';
import Cancel from '@mui/icons-material/Cancel';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import { COMPARISON_ROWS } from '../../../utils/homeData';
import './ComparisonSection.scss';

interface Props {
  onScrollToPlans: () => void;
}

export function ComparisonSection({ onScrollToPlans }: Props) {
  return (
    <section className="comparison-section">
      <div className="comparison-section__header">
        <div className="section-eyebrow section-eyebrow--blue">AVULSO x ASSINATURA</div>
        <h2 className="section-title">A conta que ninguém costuma fazer</h2>
      </div>

      {/* Desktop: tabela horizontal */}
      <div className="comparison-section__table">
        <div className="comparison-section__table-head">
          <div className="comparison-section__head-cell">Critério</div>
          <div className="comparison-section__head-cell">Lava-rápido avulso</div>
          <div className="comparison-section__head-cell comparison-section__head-cell--highlight">WashPass</div>
        </div>

        {COMPARISON_ROWS.map((row) => (
          <div key={row.criteria} className="comparison-section__row">
            <div className="comparison-section__cell comparison-section__cell--criteria">{row.criteria}</div>
            <div className="comparison-section__cell comparison-section__cell--avulso">{row.avulso}</div>
            <div className="comparison-section__cell comparison-section__cell--washpass">
              <CheckCircle sx={{ fontSize: 15, color: '#22A088', flexShrink: 0, display: 'block' }} />
              <span>{row.washpass}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Mobile: dois cards verticais */}
      <div className="comparison-section__mobile-cards">
        <div className="comparison-section__mobile-card comparison-section__mobile-card--avulso">
          <div className="comparison-section__mobile-card-title">Lava-rápido avulso</div>
          {COMPARISON_ROWS.map((row) => (
            <div key={row.criteria} className="comparison-section__mobile-item">
              <Cancel sx={{ fontSize: 15, color: '#E83C3C', flexShrink: 0, display: 'block', mt: '2px' }} />
              <div>
                <span className="comparison-section__mobile-criteria">{row.criteria}: </span>
                {row.avulso}
              </div>
            </div>
          ))}
        </div>

        <div className="comparison-section__mobile-card comparison-section__mobile-card--washpass">
          <div className="comparison-section__mobile-card-title">WashPass</div>
          {COMPARISON_ROWS.map((row) => (
            <div key={row.criteria} className="comparison-section__mobile-item comparison-section__mobile-item--washpass">
              <CheckCircle sx={{ fontSize: 15, color: '#22A088', flexShrink: 0, display: 'block', mt: '2px' }} />
              <div>
                <span className="comparison-section__mobile-criteria">{row.criteria}: </span>
                {row.washpass}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="comparison-section__cta">
        <button className="btn-cta-green" onClick={onScrollToPlans}>
          <DirectionsCarIcon sx={{ fontSize: 20 }} />
          Assine já
        </button>
      </div>
    </section>
  );
}
